module.exports = __webpack_public_path__ + "img/1507829752.6c52b153.jpg";